import _mergeJSXProps from '@vue/babel-helper-vue-jsx-merge-props';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import '../style/index';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';
import {addUnit} from '../../common/utils/format';
import _route from '../../common/utils/route';

var _createNamespace = createNamespace('button'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    bem = _createNamespace2[0];

var WHITE = '#fff';
export default {
    name: getComponentName('Button'),
    data: function data() {
        return {};
    },
    props: {
        type: {
            type: String,
            default: 'default'
        },
        size: {
            type: String,
            default: 'md'
        },
        textColor: {
            type: String
        },
        color: {
            type: String
        },
        borderRadius: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        minWidth: [String, Number],
        disabled: Boolean,
        block: Boolean,
        round: Boolean,
        plain: Boolean,
        url: String,
        replace: Boolean,
        to: [String, Object]
    },
    methods: {
        getClasses: function getClasses() {
            var type = this.type,
                size = this.size,
                disabled = this.disabled,
                block = this.block,
                round = this.round,
                plain = this.plain;
            var arr = [
                bem([
                    type,
                    size,
                    {
                        plain: plain,
                        disabled: disabled,
                        block: block,
                        round: round
                    }
                ])
            ];
            return arr;
        },
        getStyle: function getStyle() {
            var style = {};
            var textColor = this.textColor,
                color = this.color,
                plain = this.plain,
                borderRadius = this.borderRadius,
                minWidth = this.minWidth;
            style['color'] = textColor;

            if (color) {
                style['color'] = textColor || (plain ? color : WHITE);

                if (!plain) {
                    style['background'] = color;
                }

                if (color.indexOf('gradient') !== -1) {
                    style['border'] = 0;
                } else {
                    style['borderColor'] = color;
                }
            }

            var topLeft = borderRadius.topLeft,
                topRight = borderRadius.topRight,
                bottomRight = borderRadius.bottomRight,
                bottomLeft = borderRadius.bottomLeft;

            if (topLeft || topRight || bottomRight || bottomLeft) {
                style['borderRadius'] = [topLeft || 0, topRight || 0, bottomRight || 0, bottomLeft || 0].join(' ');
            }

            if (minWidth) {
                style['minWidth'] = addUnit(minWidth);
            }

            return style;
        },
        onClick: function onClick(event) {
            var disabled = this.disabled;

            if (disabled) {
                return false;
            }

            _route.functionalRoute(this);

            this.$emit('click', event);
        }
    },
    render: function render() {
        var h = arguments[0];
        var slots = this.$slots.default;
        var attrs = {
            disabled: this.disabled
        };
        var style = this.getStyle();
        var classes = this.getClasses();
        return h(
            'button',
            _mergeJSXProps([
                {},
                {
                    attrs: attrs,
                    style: style,
                    class: classes
                },
                {
                    on: {
                        click: this.onClick
                    }
                }
            ]),
            [slots]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
